




















































import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import MatchPrincipalAccordionTable from "@/components/Agents/MatchPrincipalAccordionTable.vue";
import CompanyMixin from "@/mixins/http/Agents/Company";
import { AgentModuleConfiguration, ClientCompanyWithHierarchy } from "@/models";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import ToastInvoker from "@/utils/ToastInvoker";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { NotificationBadgeGroups } from "@/components/Agents/NotificationBadge.vue";

@Component({
  components: {
    MultiLevelSelect,
    MatchPrincipalAccordionTable,
  },
})
export default class MatchPrincipalAccordion extends Mixins(CompanyMixin) {
  @Prop() readonly companyName!: string;
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  @Getter("profile") readonly profile!: AdcontrolProfile;

  @Action("notificationsGroups/reload")
  readonly reloadNotificationForGroup!: (
    group: NotificationBadgeGroups
  ) => void;

  state: "opened" | "closed" = "closed";
  companies: ClientCompanyWithHierarchy[] = [];
  selectedCompanyId = "";
  options: any[] = [];
  loading = false;
  resolved = false;

  @Watch("selectedCompanyId")
  onCompanyIdChanged(value: string) {
    const selectedCompany = this.companies.find(
      (company) => company.id === value
    );
    if (!selectedCompany) return;
    this.companies = this.companies.map((company) => {
      company.principalId = selectedCompany.id;
      return company;
    });
  }

  async toggleState() {
    if (this.isResolved()) return;

    if (this.state == "opened" && !this.isResolved()) {
      this.state = "closed";
      return;
    }

    this.state = "opened";
    this.loading = true;
    this.selectedCompanyId = "";
    try {
      this.companies = await this.getCompanies(
        "get_companies",
        this.profile.slug,
        {
          "filter[name]": this.companyName,
          "filter[with_hierarchy]": 1,
          include: "current_agent_company_agent_associations.*,current_agency",
          page: {
            size: "all",
          },
        }
      );
    } catch (error) {
      this.companies = [];
      ToastInvoker.errorToast("Errore durante il caricamento!", null);
    } finally {
      this.loading = false;
    }

    this.options = this.companies
      .sort((a, b) => {
        if (
          (a.currentAgentCompanyAssociation?.agencyStartDate ?? "") >
          (b.currentAgentCompanyAssociation?.agencyStartDate ?? "")
        ) {
          return -1;
        }
        if (
          (a.currentAgentCompanyAssociation?.agencyStartDate ?? "") <
          (b.currentAgentCompanyAssociation?.agencyStartDate ?? "")
        ) {
          return 1;
        }
        return 0;
      })
      .map((company) => {
        const option = {
          text: company.id,
          id: company.id,
        };
        return option;
      });
  }

  async onSave() {
    this.loading = true;
    try {
      await this.multipleAssignPrincipal(
        this.companies.map((company) => company.id),
        this.profile.slug,
        this.selectedCompanyId,
        "multiple_assign_principal"
      );
      ToastInvoker.successToast("Salvataggio effettuato con successo");
      this.resolved = true;
      this.reloadNotificationForGroup(NotificationBadgeGroups.Company);
    } catch (error) {
      ToastInvoker.errorToast("Errore durante il salvataggio!", null);
    } finally {
      this.loading = false;
    }
  }

  isResolved() {
    return this.resolved;
  }

  hideWhenResolved() {
    return this.isResolved() ? "group-resolved" : "";
  }
}
